import { FC } from "react";
import "./Member.scoped.scss";

interface MemberProps {
  level: number;
  nickname: string;
}

const Member: FC<MemberProps> = ({ level, nickname }) => {
  return (
    <div className="member">
      <img src={`/img/level/level_img/${level}.png`} alt="" />
      <b className="member__nickname">{nickname}</b>
      <span className="member__time"></span>
    </div>
  );
}

export default Member;